export default __webpack_public_path__ + "a8cd5a76d626b46450d4de420297e73e.svg";